type BorderWithPaddingProps = {
  padding: string
}

export function BorderWithPadding({ padding }: BorderWithPaddingProps) {
  return (
    <div className={`w-full ${padding}`}>
      <div className="w-full h-[1px] bg-[#F0F4F7]" />
    </div>
  )
}
